<div id="sidenav-loc-law-card-chart" fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="loan.customerFacingStatus === loanStatus.Repayment || loan.customerFacingStatus === loanStatus.NeedsAttention">
    <span class="title white">{{loan?.loanInfo?.principalBalance | currency:'$'}}</span>
    <div fxLayout="row" fxLayoutAlign="center center" class="mat-headline-6">
      <span>Balance</span>
    </div>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="loan.customerFacingStatus === loanStatus.PaymentDue">
    <span *ngIf="casePaymentWithinDays > 0">
      This case has been moved to case resolution. The case loan balance of ${{loan?.loanInfo?.principalBalance}} must be
      paid in full within {{casePaymentWithinDays}} day(s), {{loan?.fullRepaymentDueDate | date: 'mediumDate'}}
    </span>
    <span *ngIf="casePaymentWithinDays <= 0">
      Full payment is past due as of {{loan?.fullRepaymentDueDate | date: 'mediumDate'}}.
      The case loan balance of ${{loan?.loanInfo?.principalBalance}} must be paid in full to avoid penalties
    </span>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="loan.customerFacingStatus !== loanStatus.Repayment && loan.customerFacingStatus !== loanStatus.PaymentDue && loan.customerFacingStatus !== loanStatus.NeedsAttention">
    <span class="title white">{{loan?.loanInfo?.availableFunds | currency:'$'}}</span>
    <div fxLayout="row" fxLayoutAlign="center center" class="mat-headline-6">
      <span>Available</span>
      <mat-icon *ngIf="loan?.productCode === productCodes.Law" (click)="showAvailableFundsDialog()">info</mat-icon>
    </div>
  </div>
  <mat-progress-bar mode="determinate" [value]="utilization" color="white" *ngIf="!casePaymentRequired"></mat-progress-bar>
  <div fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="24px" class="layout padding-top">
    <button mat-flat-button (click)="onClickDraw()" [disabled]="!drawEnabled"
      *ngIf="!hasAvailableRenewalToSign && drawEnabled" [fxHide.lt-sm]="showAvailableFunds"
      [fxHide.lt-md]="widgetLayout" name="draw">
      <span class="avatar medium action-icon bg-primary">D</span>
      <span class="color-primary">DRAW</span>
    </button>
    <button mat-flat-button (click)="onClickPayment()" *ngIf="payEnabled && !resolveCaseEnabled"
      [fxHide.lt-sm]="showAvailableFunds" [fxHide.lt-md]="widgetLayout">
      <span class="avatar medium action-icon bg-primary">P</span>
      <span class="color-primary">PAY</span>
    </button>
    <button mat-flat-button (click)="resolveCase()" *ngIf="resolveCaseEnabled"
    [fxHide.lt-sm]="showAvailableFunds" [fxHide.lt-md]="widgetLayout">
    <span class="avatar medium action-icon bg-primary">P</span>
    <span class="color-primary">PAYOFF</span>
  </button>
  </div>
</div>
